import React from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa";

const PaymentFailed = () => {
  const navigate = useNavigate();

  return (
    <Container className="text-center mt-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <FaExclamationTriangle size={60} className="text-danger mb-3" />
          <h2 className="text-danger">Payment Failed</h2>
          <p className="text-muted">
            Oops! Your payment was not successful. Please try again or contact support on support@priests.africa or WhatsApp +447867221245
          </p>
          {/* <Button variant="primary" onClick={() => navigate("/checkout")}>
            Retry Payment
          </Button> */}
          <Button variant="link" className="mt-3" onClick={() => navigate("/")}>
            Go Back Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentFailed;
